import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';
import PublicPageLayout from './PublicPageLayout';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const { forgotPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await forgotPassword(email);

    if (result.success) {
      setSubmitted(true);
      toast.success(result.message || 'If that email exists, a reset link was sent.');
    } else {
      setError(result.error);
      toast.error('Unable to send reset link');
    }

    setLoading(false);
  };

  return (
    <PublicPageLayout subtitle="Reset your password">
      {error && <Alert variant="danger">{error}</Alert>}

      {submitted ? (
        <Alert variant="success">
          If an account exists for that email, a password reset link has been sent.
          Check your inbox (and spam folder), then follow the link to choose a new password.
          <div className="mt-3">
            <Link to="/login">Back to sign in</Link>
          </div>
        </Alert>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your account email"
            />
            <Form.Text className="text-muted">
              We will email a one-time link to reset your password.
            </Form.Text>
          </Form.Group>

          <Button
            variant="primary"
            type="submit"
            className="w-100"
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send reset link'}
          </Button>

          <div className="text-center mt-3">
            <Link to="/login">Back to sign in</Link>
          </div>
        </Form>
      )}
    </PublicPageLayout>
  );
}

export default ForgotPassword;
